/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Gemini_Cli_AddInputs */

const en_mcp_gemini_cli_add = /** @type {(inputs: Mcp_Gemini_Cli_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run this command, then start gemini and run /mcp auth listening to sign in.`)
};

const es_mcp_gemini_cli_add = /** @type {(inputs: Mcp_Gemini_Cli_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecuta este comando, luego inicia gemini y ejecuta /mcp auth listening para iniciar sesión.`)
};

/**
* | output |
* | --- |
* | "Run this command, then start gemini and run /mcp auth listening to sign in." |
*
* @param {Mcp_Gemini_Cli_AddInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_gemini_cli_add = /** @type {((inputs?: Mcp_Gemini_Cli_AddInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Gemini_Cli_AddInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_gemini_cli_add(inputs)
	return en_mcp_gemini_cli_add(inputs)
});